import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://kwan-api.virtueanalytics.com'
});

export default instance;